import { render, staticRenderFns } from "./PartRoleUsers.vue?vue&type=template&id=e019bee4"
import script from "./PartRoleUsers.vue?vue&type=script&setup=true&lang=js"
export * from "./PartRoleUsers.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e019bee4')) {
      api.createRecord('e019bee4', component.options)
    } else {
      api.reload('e019bee4', component.options)
    }
    module.hot.accept("./PartRoleUsers.vue?vue&type=template&id=e019bee4", function () {
      api.rerender('e019bee4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/role/components/PartRoleUsers.vue"
export default component.exports